import { render } from "./OnlineAppointment.vue?vue&type=template&id=3313219a&ts=true"
import script from "./OnlineAppointment.vue?vue&type=script&lang=ts"
export * from "./OnlineAppointment.vue?vue&type=script&lang=ts"

import "./OnlineAppointment.vue?vue&type=style&index=0&id=3313219a&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__